import { DevicesView } from "./_components";

export default function DevicesPage() {
  return <DevicesView />;
}
